export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fileUpload.vue?vue&type=template&id=148a7c82&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/fileUpload.vue?vue&type=template&id=148a7c82&scoped=true&
// module id = null
// module chunks = 